var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('StateChip',{staticClass:"ml-2",attrs:{"icon":_setup.getRecordIcon(_vm.state),"state":_vm.state}})
}
var staticRenderFns = []

export { render, staticRenderFns }